import styled from "styled-components";

import { MEDIA_MOBILE_BREAKPOINT } from "src/apps/config/constants";
import { useCommonImages } from "src/apps/hooks/useCommonImages";
import { CommonImageKeys } from "src/contexts/_shared/domain/ImageKeys";
import { colors } from "@permisso/permisso-components";

export const OpenAdminLogos = () => {
  return (
    <AdminIconsContainer>
      <Shape>
        <AdminIcon src={useCommonImages(CommonImageKeys.SEG_SOCIAL_ROUNDED_LOGO)} width={30} />
      </Shape>
      <Shape>
        <AdminIcon src={useCommonImages(CommonImageKeys.AEAT_ROUNDED_LOGO)} width={40} />
      </Shape>
    </AdminIconsContainer>
  );
};

const Shape = styled.div`
  display: flex;
  width: 2.75rem;
  height: 2.75rem;
  align-items: center;
  justify-content: center;
  background-color: ${colors.grey0};
  border-radius: 0.5rem;
  filter: drop-shadow(0.927px 0.927px 4.644px rgba(0, 0, 0, 0.08));
`;

const AdminIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.25rem;

  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    gap: 0.375rem;
  }
`;

const AdminIcon = styled.img`
  aspect-ratio: 1;
`;
